// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Select, { SelectProps } from "@insite/mobius/Select";

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import * as React from "react";

interface OwnProps extends WidgetProps {}

export interface MyListsSortControlStyles {
    wrapper?: InjectableCss;
    select?: SelectProps;
}

export const sortControlStyles: MyListsSortControlStyles = {};

const styles = sortControlStyles;

const BuyingListsManagementSort: React.FunctionComponent = () => {
    const { setSort } = useBuyingList();
    return (
        <StyledWrapper {...styles.wrapper}>
            <Select
                data-test-selector="myLists_sort"
                {...styles.select}
                onChange={(event: React.FormEvent<HTMLSelectElement>) => setSort(event.currentTarget.value)}
            >
                <option value="ModifiedOn DESC">{translate("Last Updated")}</option>
                <option value="Name ASC">{translate("List Name: A-Z")}</option>
                <option value="Name DESC">{translate("List Name: Z-A")}</option>
            </Select>
        </StyledWrapper>
    );
};

const widgetModule: CustomWidgetModule = {
    component: BuyingListsManagementSort,
    definition: {
        group: "Buying List",
    },
};

export default widgetModule;
